import React from 'react'
import './AmbassadorInfo.less'
import moment from 'moment'
import { GetTabs } from './Tabs/GetTabs.component'


interface AmbassadorInfoProps extends FunctionsToProps {
  data: ChallengeDataRecord
  onAfterSocialShare?: any
  toggleModal?: () => void
  onAmbssadorProfile: boolean;
  ambassadorProfile: AmbassadorProfileRecord
}

interface FunctionsToProps {
  getConvertedCurrencyValue: (value: number) => string
  getDaysRemaining: (EndDate: string) => string
  getPercentageFunded: (currentValue: number, goalvalue: number) => number
}

export const AmbassadorInfo = (props: AmbassadorInfoProps) => {
  const { toggleModal, onAmbssadorProfile, ambassadorProfile } = props

  return (
    <div
      className="modal fade in"
      id="ambassadorChallengePopup"
      aria-labelledby="ambassadorChallengePopup"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              <span className="challengeStartEndDate">
                {moment(props.data.ChallengeStartDate).format('YYYY/MM/DD HH:mm')} - {moment(props.data.ChallengeEndDate).format('YYYY/MM/DD HH:mm')}
              </span>
            </div>
            <button
              type="button"
              className="close modalCloseIcon"
              data-dismiss="modal"
              aria-label="Close"
              onClick={toggleModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
          <GetTabs
           data= {props.data}
           getPercentageFunded={props.getPercentageFunded}
           key={0}
           onAfterSocialShare={props.onAfterSocialShare}
           getConvertedCurrencyValue={props.getConvertedCurrencyValue}
           getDaysRemaining={props.getDaysRemaining}
           toggleModal={props.toggleModal}
           onAmbssadorProfile= {onAmbssadorProfile}
           ambassadorProfile= {ambassadorProfile}
          />
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="modalCloseBtn"
              data-dismiss="modal"
              aria-label="Close"
              onClick={toggleModal}
            >
              <span aria-hidden="true">Close</span>
            </button>*/}
            </div>
        </div>
      </div>
    </div>
  )
}
